import { jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps, TeaserCard, CardContent, CardTitle } from "@wsui/base";
import "react";
function DefaultHit(props) {
  props = useThemeProps({
    props,
    name: "AlgoliaDefaultHit"
  });
  props = useThemeProps({
    props,
    name: "AlgoliaHit"
  });
  let {
    hit,
    horizontalContentMaxWidth = "100%",
    // eslint-disable-next-line no-unused-vars
    hitsOwnerState,
    ...restProps
  } = props;
  const {
    title,
    url
  } = hit;
  return /* @__PURE__ */jsx(TeaserCard, {
    link: {
      url
    },
    title,
    as: "li",
    horizontalContentMaxWidth,
    ...restProps,
    children: /* @__PURE__ */jsx(CardContent, {
      children: /* @__PURE__ */jsx(CardTitle, {})
    })
  });
}
export { DefaultHit as default };